import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function AmountUnit(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Единица продажба';
    }

    const getType = () => {
        return 'amount_unit';
    }

    const getTitle = () => {
        return 'Количество, което се изтегля от склада при единична продажба';
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(AmountUnit)